module.exports = __webpack_public_path__ + "FuturaStd-Heavy.otf?0d7fbc4cc43a12f3fea29c8b55ed1a62";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FuturaStd-Heavy.otf
// module id = 93
// module chunks = 0